import { ServiceNames, BaseParentDocumentService } from "./BaseDocumentService";
import { ClientData } from "@/models/ClientData";
import { ClientStatistics } from "@/models/ClientStatistics";

export class ClientsService extends BaseParentDocumentService<ClientData> {
  serviceName = ServiceNames.Clients;
  async getStats(): Promise<ClientStatistics[]> {
    const results = await this.client.get<ClientStatistics[]>(
      `/api/${this.serviceName}/stats`
    );
    return results.data;
  }

  async getDocuments(): Promise<ClientData[]> {
    const results = await this.client.get<ClientData[]>(
      `/api/${this.serviceName}/document`
    );
    return results.data;
  }
}
